<template>
  <GroupTable
    :longTableId="longTableId"
    :cols="cols"
    :formData="formData"
  />
</template>

<script>
import GroupTable from "@/components/statistics/stats/tabs/clickmap/GroupTable.vue";

export default {
  components: {
    GroupTable,
  },

  props: ["value"],

  data() {
    return {
      longTableId: "clickmap-table",
      cols: {
        total: {
          label: this.$t(`campaign.statistics.clickmapTable.total`),
        },
        percent: {
          label: this.$t(`campaign.statistics.clickmapTable.percent`),
        },
        unique: {
          label: this.$t(`campaign.statistics.clickmapTable.unique`),
        },
        link: {
          label: this.$t(`campaign.statistics.clickmapTable.link`),
          className: "bold",
        },
      },
    };
  },

  methods: {
    formData() {
      if (this.value) {
        return this.value.map(i => {
          return {
            total: i.total,
            percent: i.percent,
            unique: i.unique,
            link: i.link,
          };
        });
      }
    },
  },
};
</script>